import {Component, input} from '@angular/core';
import {NgStyle} from '@angular/common';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatRipple} from '@angular/material/core';
import {AppDropdownDirective} from '../../directives/dropdown.directive';
import {DropdownLinkDirective} from '../../directives/dropdown-link.directive';
import {DropdownAnchorDirective} from '../../directives/dropdown-anchor.directive';

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.template.html',
    standalone: true,
    imports: [
    RouterModule,
    TranslateModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatTooltipModule,
    MatRipple,
    AppDropdownDirective,
    DropdownLinkDirective,
    DropdownAnchorDirective,
    NgStyle
]
})
export class SidenavComponent {
  public readonly menuItems = input<any[]>([]);
  public readonly hasIconTypeMenuItem = input<boolean>(undefined);
  public readonly iconTypeMenuTitle = input<string>(undefined);

  constructor() {}

  // Only for demo purpose
  addMenuItem() {
    this.menuItems().push({
      name: 'ITEM',
      type: 'dropDown',
      tooltip: 'Item',
      icon: 'done',
      state: 'material',
      sub: [
        {name: 'SUBITEM', state: 'cards'},
        {name: 'SUBITEM', state: 'buttons'}
      ]
    });
  }
}
